import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";

import "./styles/globals.css";

if (typeof window !== "undefined") {
  const navigatorWithUAData = window.navigator as Navigator & {
    userAgentData?: { platform?: string };
  };
  const platform = navigatorWithUAData.userAgentData?.platform ?? window.navigator.platform ?? "";
  const isMac = /mac/i.test(platform);
  document.documentElement.dataset.platform = isMac ? "mac" : "non-mac";
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
